// extracted by mini-css-extract-plugin
module.exports = {"active":"AlertChip_active__G-daY","inactive":"AlertChip_inactive__78iMR"};